import React from "react"

import {FieldTableCellProps} from "../../../../../render/table/table-cell"
import {ItemModelV2_CalculatedValues} from "../../../../../../model2/item2/calculated/@type"

type State = {
    isHovered   : boolean
}

// const debug = "FieldTimeReportMinutes_TableCellCalculated"
const debug = false

export default class FieldTimeReportMinutes_TableCellCalculated extends React.Component<FieldTableCellProps, State> {

    constructor(props:FieldTableCellProps) {
        super(props)

        this.state = {
            isHovered   : false,
        }
    }

    get style() {
        // this is common part for table cell
        // end common part

        const width = this.props.column.width

        const style : style = _.clone(this.props.style) || {} // we need clone here because we add width!
        style.width = width

        return style
    }

    renderHovered() {
        const classes = Classes("cell-flex ui5-txt-less-important-small is-hovered", this.props.column.id,)

        /*let reportedTime        = 0
        let showSummary         = false

        // when collapsed show combined reported time from this item and its children
        // if (this.props.listItem.isCollapsed && this.props.listItem.childrenItems.length > 0) {
        if (this.props.listItem.view.isCollapsed && this.props.listItem.tree.children.length > 0) {
            reportedTime = this.props.listItem.calculated.reported.total;
            showSummary = !!this.props.listItem.calculated.reported.children
        } else {
            reportedTime = this.props.listItem.calculated.reported.own;
        }*/

        const showSummaryView   = /*this.props.listItem.isGroup ||*/ this.props.listItem.view.isCollapsed

        const calculatedValues: ItemModelV2_CalculatedValues | undefined = this.props.listItem.calculated.dataByAggregateFunction[this.props.field.fieldId as keyof {}]?.[this.props.column.aggregateFunction!]
        const ownValue = calculatedValues?.own || this.props.field.getViewValue(this.props.listItem.item)
        let reportedTime
        let aggregateIcon

        if (showSummaryView && !!calculatedValues?.total.value && calculatedValues.total.value != calculatedValues.own) {
            reportedTime = calculatedValues.total.value
            aggregateIcon = <div className={Classes("ui5-ico-12 m-r-5 m-t-1", this.props.column.aggregator?.icon)}/>
        } else if (ownValue > 0) {
            reportedTime = ownValue
        }

        const showReportedTime = !!reportedTime

        return (
            <div className={classes} style={this.style}>
                <div className  = "ui5-field-editable size-small is-hovered w-100-percent h-100-percent">

                    <div className="flex-row-left-center truncate">
                        {showReportedTime &&
                            <>
                                {aggregateIcon}

                                <span className="ui5-txt-less-important-small">
                                    {gd.utils.minutesHumanize(Math.round(reportedTime))}
                                </span>
                            </>
                        }
                    </div>
                </div>
            </div>
        )
    }

    renderNotHovered() {
        const classes = Classes("cell-flex flex-justify-start ui5-txt-less-important-small ui5-field-editable size-small", this.props.column.id)

        /*let reportedTime = 0
        let showSummary = false

        // when collapsed show combined reported time from this item and its children
        // if (this.props.listItem.isCollapsed && this.props.listItem.childrenItems.length > 0) {
        if (this.props.listItem.view.isCollapsed && this.props.listItem.tree.children.length > 0) {
            reportedTime = this.props.listItem.calculated.reported.total
            showSummary = !!this.props.listItem.calculated.reported.children
        } else {
            reportedTime = this.props.listItem.calculated.reported.own
        }*/

        const showSummaryView   = /*this.props.listItem.isGroup ||*/ this.props.listItem.view.isCollapsed
        let notHoveredContent   = null
        let aggregateIcon

        const calculatedValues: ItemModelV2_CalculatedValues | undefined = this.props.listItem.calculated.dataByAggregateFunction[this.props.field.fieldId as keyof {}]?.[this.props.column.aggregateFunction!]
        const ownValue = calculatedValues?.own || this.props.field.getViewValue(this.props.listItem.item)

        debug && console.log(debug, "renderNotHovered", this.props.listItem.debugName, this.props.field.fieldId, showSummaryView, calculatedValues, this.props.listItem.calculated)

        if (showSummaryView && !!calculatedValues?.total.value && calculatedValues.total.value != calculatedValues.own) {
            notHoveredContent = calculatedValues.total.value
            aggregateIcon = <div className={Classes("ui5-ico-12 m-r-5 m-t-1", this.props.column.aggregator?.icon)}/>
        } else if (ownValue > 0) {
            notHoveredContent = ownValue
        }

        const showTimer = !!gd.taskTimers.getTimer(this.props.listItem.task.id)
        const showReportedTime = !showTimer && notHoveredContent

        return (
            <div className      = {classes}
                 style          = {this.style}
            >

                {showReportedTime &&
                    <div className="flex-row-left-center truncate">
                        {aggregateIcon}

                        <span className="ui5-txt-less-important-small">
                            {gd.utils.minutesHumanize(Math.round(notHoveredContent))}
                        </span>
                    </div>}
            </div>
        )

    }

    render() {
        debug && console.log(debug, 'render', this.props.listItem.debugName)

        if (this.state.isHovered) {
            return this.renderHovered()
        } else {
            return this.renderNotHovered()
        }
    }
}



